// portals really should not be cached, and rather refreshed with the token but no real choice right now..
import {WorkforceClinicPortal} from "../AppState";

export function SetLoginPortals(Clinics: WorkforceClinicPortal[]){
    sessionStorage.setItem("wf2-STRY0045127-portals", JSON.stringify(Clinics));
}
export function GetLoginPortals(): WorkforceClinicPortal[] | null {
    const storageForPortals = sessionStorage.getItem("wf2-STRY0045127-portals")
    if(!storageForPortals){
        return null;
    }
    return JSON.parse(storageForPortals);
}

export function setOrphanedResultsCount(orphanedResultsCount: number) {
    sessionStorage.setItem("OrphanedResultsCount", orphanedResultsCount.toString());
    window.dispatchEvent(new Event('storage'));
}

export function getOrphanedResultsCount(): number {
    const orphanedResultsCount = sessionStorage.getItem("OrphanedResultsCount")
    let result = -1
    if (orphanedResultsCount) {
        result = parseInt(orphanedResultsCount)
        if (isNaN(result)) {
            result = -1
        }
    }
    return result
}